import React from "react";
import PostCreator from '../components/CreatePrivateFeed';



function CreatePost({filterByType}) {
    return (
        <div className="create-post">
            <div className="post-section">
                <PostCreator/>
            </div>
        </div>
    );
}

export default CreatePost;